import { Dispatch, SetStateAction } from "react";

import { Affix, Box, Pagination } from "@mantine/core";

export function CustomPagination({
  totalPages,
  currentPage,
  setCurrentPage
}: Readonly<{
  totalPages: number;
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
}>) {
  return (
    <Affix style={{ zIndex: 2 }} position={{ bottom: 30, left: "50%" }}>
      <Box
        style={{
          display: "flex",
          justifyContent: "center"
        }}
      >
        <Pagination
          defaultValue={currentPage + 1}
          onChange={(_) => setCurrentPage(_ - 1)}
          total={totalPages}
          size="sm"
          radius="xl"
        />
      </Box>
    </Affix>
  );
}
